import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, OnChanges, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'rxjs';
import { CotizadorService } from '../../services/cotizador.service';
import { Prospecto } from '../../models/prospecto';
import { Planes } from '../../models/planes';
import { DecimalPipe, CurrencyPipe } from '@angular/common';
import { Cobertura } from '../../models/cobertura';
import { CoberturaAdicionalCuotas } from '../../models/coberturaAdicionalCuotas';
import { flattenStyles } from '@angular/platform-browser/src/dom/dom_renderer';
import { Descuentos } from '../../models/descuentos';
import { defaultIterableDiffers } from '@angular/core/src/change_detection/change_detection';
import { MatTooltipModule, TooltipPosition, MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-plan',
    templateUrl: './plan.component.html',
    styleUrls: ['./plan.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class PlanComponent implements OnInit, OnDestroy {


    planes: Planes;
    @ViewChild('formDirective') formFromLocal;
    data: any;
    private unsubscribeAll: Subject<any>;
    public planForm: FormGroup;

    plazos: any;
    prospecto: Prospecto;

    monedaSeleccionada = 'UDI';
    // Valores Default
    producto = 'VPL';
    moneda = 'UDI';

    plazoPagosD = '10';
    plazoSeguroD = '99';
    selectedPagos = '10';

    valorUdi;
    tipoCambio = '1';
    inflacion = '4';
    sumaDefaultUdi = 80000;
    sumaDefaultPesos = '300000';
    sumaDefaultDolares = '30000';
    tarifaBasica = 0;

    plazoSeguro: string[] = ['99'];
    plazoPagos: string[] = ['10'];
    // cuota Coberturas Adicionales
    tarifaExencion = 0;
    tarifaPAI = 0;
    tarifaCC = 0;
    cuotas: CoberturaAdicionalCuotas;
    cobertura: Cobertura;

    // Incluido Coberturas Adicionales
    incluidoBI = false;
    incluidoPAI = false;
    incluidoCC = false;
    incluidoDI = false;
    incluidoDIPO = false;
    incluidoDIPOC = false;
    incluidoIAC = false;
    incluidoPAE = false;
    incluidoPCD = false;
    incluidoGF = false;

    // Etiquetas Incluido

    lblIncluidoPCD = 'Excluido';
    lblIncluidoBI = 'Excluido';

    // VAlidacion
    validoBasica = true;
    validoBI = true;
    validoPAI = true;
    validoCC = true;
    validoDI = true;
    validoDIPO = true;
    validoDIPOC = true;
    validoIAC = true;
    validoPAE = true;
    validoPCD = true;
    validoGF = true;

    //DI
    mostrarDI = true;
    mostrarDIPO = true;
    mostrarDIPOC = true;

    dolarVisible = false;
    pesoVisible = true;
    mensajeErrorBasica = '';

    recargoFijoUdi = 200;
    recargoFijoPeso = 1000;
    recargoFijoDolar = 95;

    descuentoUdi = [];
    descuentoPeso = [];
    descuentoDolar = [];

    cargaNueva = true;

    positionOptions: TooltipPosition[] = ['above', 'below', 'left', 'right'];
    position = new FormControl(this.positionOptions[0]);

    /**
     *
     * @param formBuilder provee de funciones y objetos para la creacion y validaciÃ³n de formas.
     */
    constructor(
        private formBuilder: FormBuilder,
        private cotizadorService: CotizadorService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {
        this.unsubscribeAll = new Subject();
        // fallecimiento, exencionPAgo(BI),pagoadinv PAI,DI,dipo,dipoc, cc, iac, pae, pcd, gf

        this.matIconRegistry.addSvgIcon(
            "fallecimiento",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/fallecimiento.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "BI",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/BI.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "CC",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/CC.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "DI",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/DI.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "DIPO",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/DIPO.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "DIPOC",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/DIPOC.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "GF",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/GF.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "IAC",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/IAC.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "PAE",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/PAE.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "PAI",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/PAI.svg ")
        );

        this.matIconRegistry.addSvgIcon(
            "PCD",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/increse/PCD.svg ")
        );


    }
    /**
     * Este metodo se ejecuta al inciar el componente,
     * Creamos el formulario, nos subscribimos a la accion de creacion exitosa y mostramos mensaje,
     * creamos los observables para el listado de plan y el paginado, y cargamos los plan por default,
     * tambien reiniciamos el formulario.
     */

    ngOnInit(): void {
        //debugger;
        this.planForm = this.formBuilder.group({
            producto: new FormControl(this.producto), // , Validators.required), 
            moneda: new FormControl(this.moneda), // , Validators.required), 
            plazoSeguro: new FormControl(this.plazoSeguroD),
            plazoPagos: new FormControl(this.plazoPagosD),
            valorUdi: new FormControl(this.valorUdi),
            inflacion: new FormControl(this.inflacion),
            txtFallSumaPeso: new FormControl(null),
            txtFallSumaUdi: new FormControl(this.sumaDefaultUdi),
            txtFallSumaDolar: new FormControl(null),
            txtFallPrimaUdi: new FormControl(null),
            txtFallPrimaPeso: new FormControl(null),
            txtExenSumaPeso: new FormControl(null),
            txtExenSumaUdi: new FormControl(null),
            txtExenSumaDolar: new FormControl(null),
            txtpagoAdSumaPeso: new FormControl(null),
            txtpagoAdSumaDolar: new FormControl(null),
            txtpagoAdSumaUdi: new FormControl(null),
            txtconyuSumaPeso: new FormControl(null),
            txtconyuSumaDolar: new FormControl(null),
            txtconyuSumaUdi: new FormControl(null),
            txtmAcciSumaPeso: new FormControl(null),
            txtmAcciSumaDolar: new FormControl(null),
            txtmAcciSumaUdi: new FormControl(null),
            txtmPerOrgSumaPeso: new FormControl(null),
            txtmPerOrgSumaDolar: new FormControl(null),
            txtmPerOrgSumaUdi: new FormControl(null),
            txtmColeSumaPeso: new FormControl(null),
            txtmColeSumaDolar: new FormControl(null),
            txtmColeSumaUdi: new FormControl(null),
            txtcancerSumaPeso: new FormControl(null),
            txtcancerSumaDolar: new FormControl(null),
            txtcancerSumaUdi: new FormControl(null),
            txtenfGravSumaPeso: new FormControl(null),
            txtenfGravSumaDolar: new FormControl(null),
            txtenfGravSumaUdi: new FormControl(null),
            txtDesempSumaUdi: new FormControl(null),
            txtDesempSumaPeso: new FormControl(null),
            txtDesempSumaDolar: new FormControl(null),
            txtfuneSumaPeso: new FormControl(null),
            txtfuneSumaDolar: new FormControl(null),
            txtfuneSumaUdi: new FormControl(null),

        });

        this.inicializCuotas();
        this.inicializaPlanes();

        this.cotizadorService.obtenerDescuentos().subscribe((descuentos: any) => {

            let desc: any = descuentos.descuentos;


            desc.forEach(element => {
                if (element.moneda === 'U') {
                    this.descuentoUdi.push(element);
                } else if (element.moneda === 'P') {
                    this.descuentoPeso.push(element);
                } else if (element.moneda === 'D') {
                    this.descuentoDolar.push(element);
                }

            });

        });


        this.cotizadorService.getProspecto().subscribe((prospecto: Prospecto) => {

            if (this.cargaNueva) {
                this.prospecto = prospecto;
                this.prospecto.plan = this.producto;
                this.prospecto.producto = 'PROTGT';
                let edad = this.prospecto.edad;

                if (this.prospecto.genero != "" && this.prospecto.habito != "" && this.prospecto.edad != "") {


                    if (this.prospecto.edadMancomunado) {
                        this.cotizadorService.obtenerValoresMancomunados(
                            this.prospecto.edad, this.prospecto.edadMancomunado
                        ).subscribe(data => {
                            if (data.mancomunado[0].valor) {
                                edad = data.mancomunado[0].valor;
                                this.prospecto.edad = edad;
                            }

                            const cobertura: Cobertura = {
                                plan: this.producto,
                                cobertura: '',
                                plazoPago: this.plazoPagosD,
                                plazoSeguro: this.plazoSeguroD,
                                moneda: this.monedaSeleccionada,
                                sexo: this.prospecto.genero,
                                fumador: this.prospecto.habito,
                                edad: edad,
                                tarifa: ''

                            };

                            this.cotizadorService.obtenerTarifasCoberturas(
                                cobertura
                            ).subscribe(data => {
                                debugger;
                                //console.log(data);
                                this.inicializCuotas();
                                this.asignaCuotas(data.tarifas);
                                this.actualizaCoberturaBasica(this.sumaDefaultUdi, 'txtfallSumaUdi');
                                this.cotizadorService.setPlanes(this.planes);

                            });

                        });
                    } else {

                        const cobertura: Cobertura = {
                            plan: this.producto,
                            cobertura: '',
                            plazoPago: this.plazoPagosD,
                            plazoSeguro: this.plazoSeguroD,
                            moneda: this.monedaSeleccionada,
                            sexo: this.prospecto.genero,
                            fumador: this.prospecto.habito,
                            edad: edad,
                            tarifa: ''

                        };

                        this.cotizadorService.obtenerTarifasCoberturas(
                            cobertura
                        ).subscribe(data => {
                            //console.log(data);
                            this.inicializCuotas();
                            this.asignaCuotas(data.tarifas);
                            this.actualizaCoberturaBasica(this.sumaDefaultUdi, 'txtfallSumaUdi');
                            this.cotizadorService.setPlanes(this.planes);

                        });
                    }



                    this.cotizadorService.obtenerValorUdi().subscribe(data => {
                        this.valorUdi = data.result;
                        this.prospecto.valorUdi = +this.valorUdi;
                    });

                    this.cotizadorService.obtenerValorDolar().subscribe(data => {
                        this.tipoCambio = data.result;
                    });


                    this.cotizadorService.obtenerPlazos(
                        this.producto
                    ).subscribe(data => {
                        // //debugger;
                        if (this.plazoPagos.length < 2) {


                            this.plazoPagos = [];
                            this.plazoSeguro = [];
                            data.plazos.forEach(element => {

                                if (!this.plazoPagos.includes(element.PlazoPago)) {
                                    this.plazoPagos.push(element.PlazoPago);
                                }

                                if (!this.plazoSeguro.includes(element.PlazoSeguro)) {
                                    this.plazoSeguro.push(element.PlazoSeguro);

                                }

                            });

                            this.planForm.controls['plazoPagos'].setValue(this.plazoPagos[2]);
                            this.planForm.controls['plazoSeguro'].setValue(this.plazoSeguro[0]);
                        }

                        if (this.monedaSeleccionada === 'UDI') {
                            //  //debugger;
                            this.desactivaCamposPesos();
                            this.prospecto.sumaAsegurada = this.planes.fallSumaUdi;
                            this.prospecto.primaAnual = this.planes.fallPrimaUdi;

                        } else if (this.monedaSeleccionada === 'PESOS') {
                            this.activaCamposPesos();
                            this.prospecto.sumaAsegurada = this.planes.fallSumaPeso;
                            this.prospecto.primaAnual = this.planes.fallPrimaPeso;
                        } else if (this.monedaSeleccionada === 'DOLARES') {
                            this.dolarVisible = true;
                            this.pesoVisible = false;
                            this.prospecto.sumaAsegurada = this.planes.fallSumaDolar;
                            this.prospecto.primaAnual = this.planes.fallPrimaDolar;
                        }

                        //  //debugger;
                        if (this.prospecto.moneda == '' || this.prospecto.moneda == null || this.prospecto.moneda == undefined) {
                            this.prospecto.moneda = 'UDI';
                            this.prospecto.plazoPagos = 10;
                            this.prospecto.plazoSeguro = 99;
                            this.prospecto.valorUdi = +this.valorUdi;
                            this.prospecto.inflacion = +this.inflacion;
                            this.monedaSeleccionada = this.moneda;

                            this.cotizadorService.setProspecto(this.prospecto);

                        }

                    });
                }
            } else {
                this.cargaNueva = true;
            }
        });
    }
    /**
     * Inicializamos los valores del formulario.
     */

    inicializaFormulario(): any {

        this.planForm.reset();
        this.planForm.updateValueAndValidity();

    }
    /**
     * 
     */
    onSelectPaqueteChange(evento: any): void {

        let paquete: string = evento.value;

        this.cotizadorService.obtenerPlazos(
            paquete
        ).subscribe(data => {

            this.plazoPagos = [];
            this.plazoSeguro = [];
            data.plazos.forEach(element => {

                this.plazoPagos.push(element.PlazoPago);
                this.plazoSeguro.push(element.PlazoSeguro);
            });



            const cobertura: Cobertura = {
                plan: paquete,
                cobertura: '',
                plazoPago: this.plazoPagosD,
                plazoSeguro: this.plazoSeguroD,
                moneda: this.monedaSeleccionada,
                sexo: this.prospecto.genero,
                fumador: this.prospecto.habito,
                edad: this.prospecto.edad,
                tarifa: ''

            };

            this.cotizadorService.obtenerTarifasCoberturas(
                cobertura
            ).subscribe(data => {
                // //debugger;
                // console.log(data);
                this.inicializCuotas();
                this.asignaCuotas(data.tarifas);
                this.cotizadorService.setPlanes(this.planes);

                if (this.monedaSeleccionada === 'UDI') {
                    this.prospecto.sumaAsegurada = this.planes.fallSumaUdi;
                    this.prospecto.primaAnual = this.planes.fallPrimaUdi;
                } else if (this.monedaSeleccionada === 'PESOS') {
                    this.prospecto.sumaAsegurada = this.planes.fallSumaPeso;
                    this.prospecto.primaAnual = this.planes.fallPrimaPeso;
                }
                else if (this.monedaSeleccionada === 'DOLARES') {
                    this.prospecto.sumaAsegurada = this.planes.fallSumaDolar;
                    this.prospecto.primaAnual = this.planes.fallPrimaDolar;
                }

                this.prospecto.producto = paquete;
                this.cotizadorService.setProspecto(this.prospecto);

            });



        });


    }

    onSelectChangeMoneda(evento: any): void {

        this.monedaSeleccionada = evento.value;
        this.planes.moneda = evento.value;

        if (this.monedaSeleccionada === 'UDI') {
            this.desactivaCamposPesos();
            this.pesoVisible = true;
            this.dolarVisible = false;

        } else if (this.monedaSeleccionada === 'PESOS') {
            this.activaCamposPesos();
            this.pesoVisible = true;
            this.dolarVisible = false;


        } else if (this.monedaSeleccionada === 'DOLAR') {
            this.pesoVisible = false;
            this.dolarVisible = true;
        }
        //  //debugger;
        const cobertura: Cobertura = {
            plan: this.producto,
            cobertura: '',
            plazoPago: '10',
            plazoSeguro: '99',
            moneda: this.monedaSeleccionada,
            sexo: this.prospecto.genero,
            fumador: this.prospecto.habito,
            edad: this.prospecto.edad,
            tarifa: ''

        };

        this.cotizadorService.obtenerTarifasCoberturas(
            cobertura
        ).subscribe(data => {
            //  //debugger;
            // console.log(data);
            this.inicializCuotas();

            this.asignaCuotas(data.tarifas);

            if (this.monedaSeleccionada == 'UDI')
                this.actualizaCoberturaBasica(this.sumaDefaultUdi, 'txtfallSumaUdi');
            else if (this.monedaSeleccionada == 'PESOS')
                this.actualizaCoberturaBasica(this.sumaDefaultPesos, 'txtfallSumaPeso');
            else if (this.monedaSeleccionada == 'DOLARES')
                this.actualizaCoberturaBasica(this.sumaDefaultDolares, 'txtfallSumaDolar');

            this.actualizarCoberturas();
            this.cotizadorService.setPlanes(this.planes);

        });

        if (this.monedaSeleccionada === 'UDI') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaUdi;
            this.prospecto.primaAnual = this.planes.fallPrimaUdi;
        } else if (this.monedaSeleccionada === 'PESOS') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaPeso;
            this.prospecto.primaAnual = this.planes.fallPrimaPeso;
        } else if (this.monedaSeleccionada === 'DOLARES') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaDolar;
            this.prospecto.primaAnual = this.planes.fallPrimaDolar;
        }

        this.prospecto.moneda = this.monedaSeleccionada;
        this.cotizadorService.setProspecto(this.prospecto);

    }

    onSelectChangePlazoSeguro(evento: any): void {
        //  //debugger;
        this.plazoSeguroD = evento.value;

        const cobertura: Cobertura = {
            plan: this.producto,
            cobertura: '',
            plazoPago: this.plazoPagosD,
            plazoSeguro: this.plazoSeguroD,
            moneda: this.monedaSeleccionada,
            sexo: this.prospecto.genero,
            fumador: this.prospecto.habito,
            edad: this.prospecto.edad,
            tarifa: ''

        };

        this.cotizadorService.obtenerTarifasCoberturas(
            cobertura
        ).subscribe(data => {
            //  //debugger;
            //console.log(data);
            this.inicializCuotas();

            this.asignaCuotas(data.tarifas);
            this.actualizarCoberturas();
            this.cotizadorService.setPlanes(this.planes);

        });


        if (this.monedaSeleccionada === 'UDI') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaUdi;
            this.prospecto.primaAnual = this.planes.fallPrimaUdi;
        } else if (this.monedaSeleccionada === 'PESOS') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaPeso;
            this.prospecto.primaAnual = this.planes.fallPrimaPeso;
        } else if (this.monedaSeleccionada === 'DOLARES') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaDolar;
            this.prospecto.primaAnual = this.planes.fallPrimaDolar;
        }

        this.prospecto.plazoSeguro = +this.plazoSeguroD;
        this.cotizadorService.setProspecto(this.prospecto);
    }

    onSelectChangePlazoPagos(evento: any): void {

        this.plazoPagosD = evento.value;

        const cobertura: Cobertura = {
            plan: this.producto,
            cobertura: '',
            plazoPago: this.plazoPagosD,
            plazoSeguro: this.plazoSeguroD,
            moneda: this.monedaSeleccionada,
            sexo: this.prospecto.genero,
            fumador: this.prospecto.habito,
            edad: this.prospecto.edad,
            tarifa: ''

        };

        this.cotizadorService.obtenerTarifasCoberturas(
            cobertura
        ).subscribe(data => {
            // //debugger;
            // console.log(data);
            this.inicializCuotas();

            this.asignaCuotas(data.tarifas);
            this.actualizarCoberturas();
            this.cotizadorService.setPlanes(this.planes);

        });


        if (this.monedaSeleccionada === 'UDI') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaUdi;
            this.prospecto.primaAnual = this.planes.fallPrimaUdi;
        } else if (this.monedaSeleccionada === 'PESOS') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaPeso;
            this.prospecto.primaAnual = this.planes.fallPrimaPeso;
        } else if (this.monedaSeleccionada === 'DOLARES') {
            this.prospecto.sumaAsegurada = this.planes.fallSumaDolar;
            this.prospecto.primaAnual = this.planes.fallPrimaDolar;
        }

        this.selectedPagos = this.plazoPagosD;
        this.prospecto.plazoPagos = +this.plazoPagosD;
        this.cotizadorService.setProspecto(this.prospecto);


    }

    /**
     * Este mÃ©todo se ejecuta cuando el componente es destruido y eliminamos las subscripciones que esten activas.
     */
    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    actualizarCoberturas() {
        //debugger;
        this.actualizaValidacionCoberturas();
        if (this.monedaSeleccionada == 'UDI')
            this.actualizaCoberturaBasica(this.sumaDefaultUdi, 'txtfallSumaUdi');
        else if (this.monedaSeleccionada == 'PESOS')
            this.actualizaCoberturaBasica(this.sumaDefaultPesos, 'txtfallSumaPeso');
        else if (this.monedaSeleccionada == 'DOLARES')
            this.actualizaCoberturaBasica(this.sumaDefaultDolares, 'txtfallSumaDolar');

        if (this.incluidoBI)
            this.actualizaBI();
        if (this.incluidoPAI)
            this.actualizaPAI();
        if (this.incluidoCC)
            this.actualizaCC();
        if (this.incluidoDI)
            this.actualizaDI();
        if (this.incluidoDIPO)
            this.actualizaDIPO();
        if (this.incluidoDIPOC)
            this.actualizaDIPOC();
        if (this.incluidoIAC)
            this.actualizaIAC();
        if (this.incluidoPAE)
            this.actualizaPAE();
        if (this.incluidoPCD)
            this.actualizaPCD();
        if (this.incluidoGF)
            this.actualizaGF();

    }

    inicializaPlanes(): void {
        //debugger;
        this.planes = {
            fallSumaPeso: 0,
            fallSumaDolar: 0,
            fallSumaUdi: +this.sumaDefaultUdi,
            fallPrimaPeso: 0,
            fallPrimaDolar: 0,
            fallPrimaUdi: 0,

            exenPrimaPeso: 0,
            exenPrimaDolar: 0,
            exenPrimaUdi: 0,

            pagoAdSumaPeso: 0,
            pagoAdSumaDolar: 0,
            pagoAdSumaUdi: 0,
            pagoAdPrimaPeso: 0,
            pagoAdPrimaDolar: 0,
            pagoAdPrimaUdi: 0,

            conyuSumaPeso: 0,
            conyuSumaDolar: 0,
            conyuSumaUdi: 0,
            conyuPrimaPeso: 0,
            conyuPrimaDolar: 0,
            conyuPrimaUdi: 0,

            mAcciSumaPeso: 0,
            mAcciSumaDolar: 0,
            mAcciSumaUdi: 0,
            mAcciPrimaPeso: 0,
            mAcciPrimaDolar: 0,
            mAcciPrimaUdi: 0,

            mPerOrgSumaPeso: 0,
            mPerOrgSumaDolar: 0,
            mPerOrgSumaUdi: 0,
            mPerOrgPrimaPeso: 0,
            mPerOrgPrimaDolar: 0,
            mPerOrgPrimaUdi: 0,

            mColeSumaPeso: 0,
            mColeSumaDolar: 0,
            mColeSumaUdi: 0,
            mColePrimaPeso: 0,
            mColePrimaDolar: 0,
            mColePrimaUdi: 0,

            cancerSumaPeso: 0,
            cancerSumaDolar: 0,
            cancerSumaUdi: 0,
            cancerPrimaPeso: 0,
            cancerPrimaDolar: 0,
            cancerPrimaUdi: 0,

            enfGravSumaPeso: 0,
            enfGravSumaDolar: 0,
            enfGravSumaUdi: 0,
            enfGravPrimaPeso: 0,
            enfGravPrimaDolar: 0,
            enfGravPrimaUdi: 0,

            desempPrimaPeso: 0,
            desempPrimaDolar: 0,
            desempPrimaUdi: 0,

            funeSumaPeso: 0,
            funeSumaDolar: 0,
            funeSumaUdi: 0,
            funePrimaPeso: 0,
            funePrimaDolar: 0,
            funePrimaUdi: 0,

            moneda: this.monedaSeleccionada
        };
    }

    inicializCuotas(): void {
        this.cuotas = {
            BASICA: 0,
            BI: 0,
            PAI: 0,
            CC: 0,
            DI: 0,
            DIPO: 0,
            DIPOC: 0,
            IAC: 0,
            PAE: 0,
            PCD: 0,
            GF: 0
        };
    }

    calculaPrima(Suma: number, tarifaBasica: number): number {

        let prima = (Suma / 1000) * tarifaBasica;

        return prima;
    }

    calculaPrimaBasica(Suma: number, tarifaBasica: number): number {
        //debugger;
        let prima = 0;

        if (this.monedaSeleccionada == 'UDI') {
            let descuentoRow;
            prima = (Suma / 1000) * tarifaBasica;
            descuentoRow = this.descuentoUdi.filter(function (elemento) {

                return Suma >= elemento.inferior && Suma <= elemento.superior;
            });



            if (descuentoRow.length > 0) {
                if (descuentoRow[0].descuento > 0) {
                    prima = prima / ((descuentoRow[0].descuento / 100) + 1);
                }
            }
            prima += this.recargoFijoUdi;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let descuentoRow;
            prima = (Suma / 1000) * tarifaBasica;
            descuentoRow = this.descuentoPeso.filter(function (elemento) {
                return Suma >= elemento.inferior && Suma <= elemento.superior;
            });
            if (descuentoRow.length > 0) {
                if (descuentoRow[0].descuento > 0) {
                    prima = prima / ((descuentoRow[0].descuento / 100) + 1);
                }
            }
            prima += this.recargoFijoPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let descuentoRow;
            prima = (Suma / 1000) * tarifaBasica;
            descuentoRow = this.descuentoDolar.filter(function (elemento) {
                return Suma >= elemento.inferior && Suma <= elemento.superior;
            });
            if (descuentoRow.length > 0) {
                if (descuentoRow[0].descuento > 0) {
                    prima = prima / ((descuentoRow[0].descuento / 100) + 1);
                }
            }
            prima += this.recargoFijoDolar;

        }
        return prima;
    }

    calculaSumaBasica(prima: number, tarifaBasica: number): number {

        let suma = 0;

        //debugger;
        if (this.monedaSeleccionada == 'UDI') {

            prima -= this.recargoFijoUdi;
            let descuentoRow;
            suma = (prima / tarifaBasica) * 1000;
            descuentoRow = this.descuentoUdi.filter(function (elemento) {

                return suma >= elemento.inferior && suma <= elemento.superior;
            });



            if (descuentoRow.length > 0) {
                if (descuentoRow[0].descuento > 0) {
                    prima = prima / ((descuentoRow[0].descuento / 100) + 1);
                }
            }
            prima += this.recargoFijoUdi;
        }
        /*  else if (this.monedaSeleccionada == 'PESOS') {
             let descuentoRow;
             prima -= this.recargoFijoPeso;
             prima = (Suma / 1000) * tarifaBasica;
             descuentoRow = this.descuentoPeso.filter(function (elemento) {
                 return Suma >= elemento.inferior && Suma <= elemento.superior;
             });
             if (descuentoRow.length > 0) {
                 if (descuentoRow[0].descuento > 0) {
                     prima = prima / ((descuentoRow[0].descuento / 100) + 1);
                 }
             }
             prima += this.recargoFijoPeso;
         }
          else if (this.monedaSeleccionada == 'DOLARES') {
               let descuentoRow;
               prima = (Suma / 1000) * tarifaBasica;
               descuentoRow = this.descuentoDolar.filter(function (elemento) {
                   return Suma >= elemento.inferior && Suma <= elemento.superior;
               });
               if (descuentoRow.length > 0) {
                   if (descuentoRow[0].descuento > 0) {
                       prima = prima / ((descuentoRow[0].descuento / 100) + 1);
                   }
               }
               prima += this.recargoFijoDolar;
   
           }*/
        return suma;
    }

    udiToPeso(SumaUdi: number): number {
        return +this.valorUdi * SumaUdi;
    }

    pesoToUdi(pesos: number): number {
        return pesos / +this.valorUdi;
    }

    onBlurFallSumaPeso(sumaPeso): void {
        //  //debugger;
        sumaPeso = this.removeCurrencyPipeFormat(sumaPeso);

        const sumaUdi = sumaPeso / +this.valorUdi;
        const primaUdi = this.calculaPrimaBasica(sumaUdi, this.cuotas.BASICA);
        const primaPeso = this.udiToPeso(primaUdi);
        // const sumaPeso = this.udiToPeso(this.planForm.controls.txtFallSumaUdi.value);

        this.planes.fallPrimaUdi = primaUdi;
        this.planes.fallPrimaPeso = primaPeso;
        this.planes.fallSumaUdi = sumaUdi;
        this.prospecto.primaAnual = sumaPeso;
        this.prospecto.sumaAsegurada = sumaPeso;


        this.sumaDefaultPesos = sumaPeso;

        if (this.incluidoPAI)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtpagoAdSumaPeso');
        if (this.incluidoCC)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtconyuSumaPeso');

        if (this.incluidoDI)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtmAcciSumaPeso');

        if (this.incluidoDIPO)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtmPerOrgSumaPeso');

        if (this.incluidoDIPOC)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtmColeSumaPeso');

        if (this.incluidoIAC)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtcancerSumaPeso');

        if (this.incluidoPAE)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtenfGravSumaPeso');

        if (this.incluidoPCD)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtdesempSumaPeso');

        if (this.incluidoGF)
            this.actualizaCoberturaAdicional(sumaPeso, 'txtfuneSumaPeso');

        this.cargaNueva = false;
        this.cotizadorService.setPlanes(this.planes);
        this.cotizadorService.setProspecto(this.prospecto);
    }

    onBlurFallSumaDolar(sumaDolar): void {
        //  //debugger; 

        sumaDolar = this.removeCurrencyPipeFormat(sumaDolar);

        const primaDolar = this.calculaPrimaBasica(sumaDolar, this.cuotas.BASICA);


        this.planes.fallPrimaUdi = 0;
        this.planes.fallPrimaPeso = 0;
        this.planes.fallSumaUdi = 0;
        this.planes.fallPrimaUdi = 0;
        this.prospecto.sumaAsegurada = sumaDolar;
        this.prospecto.primaAnual = primaDolar;

        this.planes.fallPrimaDolar = primaDolar;
        this.planes.fallSumaDolar = sumaDolar;

        this.sumaDefaultDolares = sumaDolar;

        if (this.incluidoPAI)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtpagoAdSumaDolar');
        if (this.incluidoCC)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtconyuSumaDolar');

        if (this.incluidoDI)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtmAcciSumaDolar');

        if (this.incluidoDIPO)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtmPerOrgSumaDolar');

        if (this.incluidoDIPOC)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtmColeSumaDolar');

        if (this.incluidoIAC)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtcancerSumaDolar');

        if (this.incluidoPAE)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtenfGravSumaDolar');

        if (this.incluidoPCD)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtdesempSumaDolar');

        if (this.incluidoGF)
            this.actualizaCoberturaAdicional(sumaDolar, 'txtfuneSumaDolar');

        this.cargaNueva = false;
        this.cotizadorService.setPlanes(this.planes);
        this.cotizadorService.setProspecto(this.prospecto);
    }

    onBlurFallSumaUdi(sumaUdi): void {
        sumaUdi = this.removeCurrencyPipeFormat(sumaUdi);
        const primaUdi = this.calculaPrimaBasica(sumaUdi, this.cuotas.BASICA);
        const primaPeso = this.udiToPeso(primaUdi);
        const sumaPeso = this.udiToPeso(sumaUdi);

        this.planes.fallPrimaUdi = primaUdi;
        this.planes.fallPrimaPeso = primaPeso;
        this.planes.fallSumaPeso = sumaPeso;
        this.planes.fallSumaUdi = sumaUdi;
        this.prospecto.sumaAsegurada = sumaUdi;
        this.prospecto.primaAnual = primaUdi;

       this.sumaDefaultUdi = sumaUdi; 

        if (this.incluidoBI)
            this.actualizaBI();

        if (this.incluidoPAI)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtpagoAdSumaUdi');
        if (this.incluidoCC)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtconyuSumaUdi');

        if (this.incluidoDI)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtmAcciSumaUdi');

        if (this.incluidoDIPO)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtmPerOrgSumaUdi');

        if (this.incluidoDIPOC)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtmColeSumaUdi');

        if (this.incluidoIAC)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtcancerSumaUdi');

        if (this.incluidoPAE)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtenfGravSumaUdi');

        if (this.incluidoPCD)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtdesempSumaUdi');

        if (this.incluidoGF)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtfuneSumaUdi');

        this.cargaNueva = false;
        this.cotizadorService.setPlanes(this.planes);
        this.cotizadorService.setProspecto(this.prospecto);
    }

    onBlurFallPrimaUdi(primaUdi): void {
        //debugger;

        primaUdi = this.removeCurrencyPipeFormat(primaUdi);

        const sumaUdi = +this.calculaSumaBasica(primaUdi, this.cuotas.BASICA);
        const primaPeso = this.udiToPeso(primaUdi);
        const sumaPeso = this.udiToPeso(sumaUdi);

        this.planes.fallPrimaUdi = primaUdi;
        this.planes.fallPrimaPeso = primaPeso;
        this.planes.fallSumaPeso = sumaPeso;
        this.planes.fallSumaUdi = sumaUdi;
        this.prospecto.sumaAsegurada = sumaUdi;
        this.prospecto.primaAnual = primaUdi;

        this.sumaDefaultUdi = sumaUdi;

        if (this.incluidoPAI)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtpagoAdSumaUdi');
        if (this.incluidoCC)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtconyuSumaUdi');

        if (this.incluidoDI)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtmAcciSumaUdi');

        if (this.incluidoDIPO)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtmPerOrgSumaUdi');

        if (this.incluidoDIPOC)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtmColeSumaUdi');

        if (this.incluidoIAC)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtcancerSumaUdi');

        if (this.incluidoPAE)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtenfGravSumaUdi');

        if (this.incluidoPCD)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtdesempSumaUdi');

        if (this.incluidoGF)
            this.actualizaCoberturaAdicional(sumaUdi, 'txtfuneSumaUdi');

        this.cargaNueva = false;
        this.cotizadorService.setPlanes(this.planes);
        this.cotizadorService.setProspecto(this.prospecto);
    }

    onBlurFallPrimaPeso(primaPesos): void {
        //debugger;

        primaPesos = this.removeCurrencyPipeFormat(primaPesos);
        this.onBlurFallPrimaUdi(this.pesoToUdi(primaPesos));
        this.cargaNueva = false;
        ;

        this.cotizadorService.setProspecto(this.prospecto);

    }


    incluirBI(): void {

        if (this.incluidoBI) {
            this.planes.exenPrimaUdi = 0;
            this.planes.exenPrimaPeso = 0;
            this.planes.exenPrimaDolar = 0;
            this.incluidoBI = false;
            this.lblIncluidoBI = 'Excluido';


        } else {

            this.actualizaBI();
            this.incluidoBI = true;
            this.lblIncluidoBI = 'Incluido';
        }
        this.cotizadorService.setPlanes(this.planes);


    }

    incluirPAI(): void {
        if (this.incluidoPAI) {
            this.planes.pagoAdPrimaPeso = 0;
            this.planes.pagoAdPrimaDolar = 0;
            this.planes.pagoAdPrimaUdi = 0;
            this.planes.pagoAdSumaPeso = 0;
            this.planes.pagoAdSumaDolar = 0;
            this.planes.pagoAdSumaUdi = 0;
            this.incluidoPAI = false;
        } else {
            this.actualizaPAI()
            this.incluidoPAI = true;

        }
        this.cotizadorService.setPlanes(this.planes);
        this.validoPAI = true;


    }

    incluirCC(): void {
        // //  //debugger;
        if (this.incluidoCC) {
            this.planes.conyuPrimaPeso = 0;
            this.planes.conyuPrimaDolar = 0;
            this.planes.conyuPrimaUdi = 0;
            this.planes.conyuSumaPeso = 0;
            this.planes.conyuSumaDolar = 0;
            this.planes.conyuSumaUdi = 0;
            this.incluidoCC = false;
        } else {
            this.actualizaCC();
            this.incluidoCC = true;
        }
        this.cotizadorService.setPlanes(this.planes);
        this.validoCC = true;

    }

    incluirDI(): void {
        //debugger;
        if (this.incluidoDI) {
            this.planes.mAcciPrimaPeso = 0;
            this.planes.mAcciPrimaDolar = 0;
            this.planes.mAcciPrimaUdi = 0;
            this.planes.mAcciSumaPeso = 0;
            this.planes.mAcciSumaDolar = 0;
            this.planes.mAcciSumaUdi = 0;
            this.incluidoDI = false;
            this.mostrarDI = true;
            this.mostrarDIPO = true;
            this.mostrarDIPOC = true;
        } else {
            this.actualizaDI();
            this.cotizadorService.setPlanes(this.planes);
            this.incluidoDI = true;
            this.mostrarDI = true;
            this.mostrarDIPO = false;
            this.mostrarDIPOC = false;
        }
        this.validoDI = true;

    }

    incluirDIPO(): void {
        //debugger;
        if (this.incluidoDIPO) {
            this.planes.mPerOrgPrimaPeso = 0;
            this.planes.mPerOrgPrimaDolar = 0;
            this.planes.mPerOrgPrimaUdi = 0;
            this.planes.mPerOrgSumaPeso = 0;
            this.planes.mPerOrgSumaDolar = 0;
            this.planes.mPerOrgSumaUdi = 0;
            this.incluidoDIPO = false;
            this.mostrarDI = true;
            this.mostrarDIPO = true;
            this.mostrarDIPOC = true;
        } else {
            this.actualizaDIPO();
            this.incluidoDIPO = true;
            this.mostrarDI = false;
            this.mostrarDIPO = true;
            this.mostrarDIPOC = false;
        }
        this.cotizadorService.setPlanes(this.planes);
        this.validoDIPO = true;

    }

    incluirDIPOC(): void {
        //debugger;
        if (this.incluidoDIPOC) {
            this.planes.mColePrimaPeso = 0;
            this.planes.mColePrimaDolar = 0;
            this.planes.mColePrimaUdi = 0;
            this.planes.mColeSumaPeso = 0;
            this.planes.mColeSumaDolar = 0;
            this.planes.mColeSumaUdi = 0;
            this.incluidoDIPOC = false;
            this.mostrarDI = true;
            this.mostrarDIPO = true;
            this.mostrarDIPOC = true;
        } else {
            this.actualizaDIPOC();
            this.incluidoDIPOC = true;
            this.mostrarDI = false;
            this.mostrarDIPO = false;
            this.mostrarDIPOC = true;
        }
        this.cotizadorService.setPlanes(this.planes);
        this.validoDIPOC = true;

    }

    incluirIAC(): void {
        //  //debugger;
        if (this.incluidoIAC) {
            this.planes.cancerPrimaPeso = 0;
            this.planes.cancerPrimaDolar = 0;
            this.planes.cancerPrimaUdi = 0;
            this.planes.cancerSumaPeso = 0;
            this.planes.cancerSumaDolar = 0;
            this.planes.cancerSumaUdi = 0;
            this.incluidoIAC = false;
        } else {
            this.actualizaIAC();
            this.incluidoIAC = true;
        }
        this.validoIAC = true;
        this.cotizadorService.setPlanes(this.planes);
    }

    incluirPAE(): void {
        //  //debugger;
        if (this.incluidoPAE) {
            this.planes.enfGravPrimaPeso = 0;
            this.planes.enfGravPrimaDolar = 0;
            this.planes.enfGravPrimaUdi = 0;
            this.planes.enfGravSumaPeso = 0;
            this.planes.enfGravSumaDolar = 0;
            this.planes.enfGravSumaUdi = 0;
            this.incluidoPAE = false;
        } else {
            this.actualizaPAE();
            this.incluidoPAE = true;
        }
        this.cotizadorService.setPlanes(this.planes);
        this.validoPAE = true;
    }

    incluirPCD(): void {
        //  //debugger;
        if (this.incluidoPCD) {
            this.planes.desempPrimaPeso = 0;
            this.planes.desempPrimaDolar = 0;
            this.planes.desempPrimaUdi = 0;
            this.incluidoPCD = false;
            this.lblIncluidoPCD = 'Excluido';
        } else {
            this.actualizaPCD();
            this.incluidoPCD = true;
            this.lblIncluidoPCD = 'Incluido';

        }
        this.cotizadorService.setPlanes(this.planes);
        this.validoPCD = true;
    }

    incluirGF(): void {
        if (this.incluidoGF) {
            this.planes.funePrimaPeso = 0;
            this.planes.funePrimaDolar = 0;
            this.planes.funePrimaUdi = 0;
            this.planes.funeSumaPeso = 0;
            this.planes.funeSumaDolar = 0;
            this.planes.funeSumaUdi = 0;
            this.incluidoGF = false;
        } else {
            this.actualizaGF();
            this.incluidoGF = true;
        }
        this.cotizadorService.setPlanes(this.planes);
        this.validoGF = true;
    }

    actualizaBI(): void {
        if (this.monedaSeleccionada == 'UDI') {
            let primaUdi = 0;
            let primaPeso = 0;
            primaUdi = this.calculaPrima(this.planes.fallPrimaUdi, this.cuotas.BI);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.exenPrimaUdi = primaUdi;
            this.planes.exenPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            primaPeso = this.calculaPrima(this.planes.fallPrimaPeso, this.cuotas.BI);
            this.planes.exenPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            primaDolar = this.calculaPrima(this.planes.fallPrimaDolar, this.cuotas.BI);
            this.planes.exenPrimaDolar = primaDolar;
        }


    }

    actualizaPAI(): void {

        if (this.monedaSeleccionada == 'UDI') {
            this.planes.pagoAdSumaUdi = this.planes.fallSumaUdi;
            this.planes.pagoAdSumaPeso = this.planes.fallSumaPeso;
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.pagoAdSumaUdi, this.cuotas.PAI);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.pagoAdPrimaUdi = primaUdi;
            this.planes.pagoAdPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            this.planes.pagoAdSumaPeso = this.planes.fallSumaPeso;
            primaPeso = this.calculaPrima(this.planes.pagoAdSumaPeso, this.cuotas.PAI);
            this.planes.pagoAdPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            this.planes.pagoAdSumaDolar = this.planes.fallSumaDolar;
            primaDolar = this.calculaPrima(this.planes.pagoAdSumaDolar, this.cuotas.PAI);
            this.planes.pagoAdPrimaDolar = primaDolar;
        }

    }

    actualizaCC(): void {

        if (this.monedaSeleccionada == 'UDI') {
            this.planes.conyuSumaUdi = this.planes.fallSumaUdi;
            this.planes.conyuSumaPeso = this.planes.fallSumaPeso;
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.conyuSumaUdi, this.cuotas.CC);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.conyuPrimaUdi = primaUdi;
            this.planes.conyuPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            this.planes.conyuSumaPeso = this.planes.fallSumaPeso;
            primaPeso = this.calculaPrima(this.planes.conyuSumaPeso, this.cuotas.CC);
            this.planes.conyuPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            this.planes.conyuSumaDolar = this.planes.fallSumaDolar;
            primaDolar = this.calculaPrima(this.planes.conyuSumaDolar, this.cuotas.CC);
            this.planes.conyuPrimaDolar = primaDolar;
        }

    }

    actualizaDI(): void {

        if (this.monedaSeleccionada == 'UDI') {
            this.planes.mAcciSumaUdi = this.planes.fallSumaUdi;
            this.planes.mAcciSumaPeso = this.planes.fallSumaPeso;
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.mAcciSumaUdi, this.cuotas.DI);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.mAcciPrimaUdi = primaUdi;
            this.planes.mAcciPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            this.planes.mAcciSumaPeso = this.planes.fallSumaPeso;
            primaPeso = this.calculaPrima(this.planes.mAcciSumaPeso, this.cuotas.DI);
            this.planes.mAcciPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            this.planes.mAcciSumaDolar = this.planes.fallSumaDolar;
            primaDolar = this.calculaPrima(this.planes.mAcciSumaDolar, this.cuotas.DI);
            this.planes.mAcciPrimaDolar = primaDolar;
        }
    }

    actualizaDIPO(): void {

        if (this.monedaSeleccionada == 'UDI') {
            this.planes.mPerOrgSumaUdi = this.planes.fallSumaUdi;
            this.planes.mPerOrgSumaPeso = this.planes.fallSumaPeso;
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.mPerOrgSumaUdi, this.cuotas.DIPO);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.mPerOrgPrimaUdi = primaUdi;
            this.planes.mPerOrgPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            this.planes.mPerOrgSumaPeso = this.planes.fallSumaPeso;
            primaPeso = this.calculaPrima(this.planes.mPerOrgSumaPeso, this.cuotas.DIPO);
            this.planes.mPerOrgPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            this.planes.mPerOrgSumaDolar = this.planes.fallSumaDolar;
            primaDolar = this.calculaPrima(this.planes.mPerOrgSumaDolar, this.cuotas.DIPO);
            this.planes.mPerOrgPrimaDolar = primaDolar;
        }
    }

    actualizaDIPOC(): void {

        if (this.monedaSeleccionada == 'UDI') {
            this.planes.mColeSumaUdi = this.planes.fallSumaUdi;
            this.planes.mColeSumaPeso = this.planes.fallSumaPeso;
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.mColeSumaUdi, this.cuotas.DIPOC);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.mColePrimaUdi = primaUdi;
            this.planes.mColePrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            this.planes.mColeSumaPeso = this.planes.fallSumaPeso;
            primaPeso = this.calculaPrima(this.planes.mColeSumaPeso, this.cuotas.DIPOC);
            this.planes.mColePrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            this.planes.mColeSumaDolar = this.planes.fallSumaDolar;
            primaDolar = this.calculaPrima(this.planes.mColeSumaDolar, this.cuotas.DIPOC);
            this.planes.mColePrimaDolar = primaDolar;
        }
    }

    actualizaIAC(): void {

        if (this.monedaSeleccionada == 'UDI') {
            this.planes.cancerSumaUdi = this.planes.fallSumaUdi;
            this.planes.cancerSumaPeso = this.planes.fallSumaPeso;
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.cancerSumaUdi, this.cuotas.IAC);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.cancerPrimaUdi = primaUdi;
            this.planes.cancerPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            this.planes.cancerSumaPeso = this.planes.fallSumaPeso;
            primaPeso = this.calculaPrima(this.planes.cancerSumaPeso, this.cuotas.IAC);
            this.planes.cancerPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            this.planes.cancerSumaDolar = this.planes.fallSumaDolar;
            primaDolar = this.calculaPrima(this.planes.cancerSumaDolar, this.cuotas.IAC);
            this.planes.cancerPrimaDolar = primaDolar;
        }
    }

    actualizaPAE(): void {

        if (this.monedaSeleccionada == 'UDI') {
            this.planes.enfGravSumaUdi = this.planes.fallSumaUdi;
            this.planes.enfGravSumaPeso = this.planes.fallSumaPeso;
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.enfGravSumaUdi, this.cuotas.PAE);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.enfGravPrimaUdi = primaUdi;
            this.planes.enfGravPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            this.planes.enfGravSumaPeso = this.planes.fallSumaPeso;
            primaPeso = this.calculaPrima(this.planes.enfGravSumaPeso, this.cuotas.PAE);
            this.planes.enfGravPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            this.planes.enfGravSumaDolar = this.planes.fallSumaDolar;
            primaDolar = this.calculaPrima(this.planes.enfGravSumaDolar, this.cuotas.PAE);
            this.planes.enfGravPrimaDolar = primaDolar;
        }
    }

    actualizaPCD(): void {
        //  //debugger;
        let primaUdi = 0;
        let primaPeso = 0;
        primaUdi = this.calculaPrima(this.planes.fallPrimaUdi, this.cuotas.PCD);
        primaPeso = this.udiToPeso(primaUdi);
        this.planes.desempPrimaUdi = primaUdi;
        this.planes.desempPrimaPeso = primaPeso;

        if (this.monedaSeleccionada == 'UDI') {
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.fallSumaUdi, this.cuotas.PCD);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.desempPrimaUdi = primaUdi;
            this.planes.desempPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            primaPeso = this.calculaPrima(this.planes.fallSumaPeso, this.cuotas.PCD);
            this.planes.desempPrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            primaDolar = this.calculaPrima(this.planes.fallSumaDolar, this.cuotas.PCD);
            this.planes.desempPrimaDolar = primaDolar;
        }
    }

    actualizaGF(): void {

        if (this.monedaSeleccionada == 'UDI') {
            this.planes.funeSumaUdi = this.planes.fallSumaUdi;
            this.planes.funeSumaPeso = this.planes.fallSumaPeso;
            let primaUdi = 0;
            let primaPeso = 0;

            primaUdi = this.calculaPrima(this.planes.funeSumaUdi, this.cuotas.GF);
            primaPeso = this.udiToPeso(primaUdi);
            this.planes.funePrimaUdi = primaUdi;
            this.planes.funePrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'PESOS') {
            let primaPeso = 0;
            this.planes.funeSumaPeso = this.planes.fallSumaPeso;
            primaPeso = this.calculaPrima(this.planes.funeSumaPeso, this.cuotas.GF);
            this.planes.funePrimaPeso = primaPeso;
        }
        else if (this.monedaSeleccionada == 'DOLARES') {
            let primaDolar = 0;
            this.planes.funeSumaDolar = this.planes.fallSumaDolar;
            primaDolar = this.calculaPrima(this.planes.funeSumaDolar, this.cuotas.GF);
            this.planes.funePrimaDolar = primaDolar;
        }
    }


    actualizaCoberturaBasica(value, controlName): void {
        // txtpagoAdSumaUdi txtpagoAdSumaPeso
        //  //debugger;

        let minimo = 0;

        if (this.monedaSeleccionada === 'UDI') {
            minimo = 80000;
        } else if (this.monedaSeleccionada === 'PESOS') {
            minimo = 300000;
        } else if (this.monedaSeleccionada === 'DOLARES') {
            minimo = 30000;
        }


        value = this.removeCurrencyPipeFormat(value);

        if (value < minimo) {
            this.mensajeErrorBasica = 'La Suma Asegurada miníma es de ' + Number(minimo).toLocaleString('en-GB') + ' ' + this.monedaSeleccionada;
        } else {


            if (controlName === 'txtfallSumaUdi') {

                let sumaUdi = value;
                const primaUdi = this.calculaPrimaBasica(sumaUdi, this.cuotas.BASICA);
                const primaPeso = this.udiToPeso(primaUdi);
                const sumaPeso = this.udiToPeso(sumaUdi);

                this.planes.fallPrimaUdi = primaUdi;
                this.planes.fallPrimaPeso = primaPeso;
                this.planes.fallSumaPeso = sumaPeso;
                this.planes.fallSumaUdi = sumaUdi;

            }
            if (controlName === 'txtfallSumaPeso') {
                let sumaPeso = value;

                const sumaUdi = sumaPeso / +this.valorUdi;
                const primaPeso = this.calculaPrimaBasica(sumaPeso, this.cuotas.BASICA);

                const primaUdi = this.pesoToUdi(primaPeso);
                // const sumaPeso = this.udiToPeso(this.planForm.controls.txtFallSumaUdi.value);

                this.planes.fallPrimaUdi = primaUdi;
                this.planes.fallPrimaPeso = primaPeso;
                this.planes.fallSumaUdi = sumaUdi;
                this.planes.fallSumaPeso = sumaPeso;
            }

            if (controlName === 'txtfallSumaDolar') {
                let sumaDolar = value;


                const primaDolar = this.calculaPrimaBasica(sumaDolar, this.cuotas.BASICA);

                this.planes.fallPrimaUdi = 0;
                this.planes.fallPrimaPeso = 0;
                this.planes.fallPrimaDolar = primaDolar;
                this.planes.fallSumaUdi = 0;
                this.planes.fallSumaPeso = 0;
                this.planes.fallSumaDolar = sumaDolar;
            }


        }

    }

    actualizaCoberturaAdicional(value, controlName): void {

        value = this.removeCurrencyPipeFormat(value);


        let primaUdi;
        let sumaUdi;
        let primaPeso;
        let sumaPeso;
        let primaDolar;
        let sumaDolar;


        if (controlName === 'txtpagoAdSumaUdi') {
            if (value > this.planes.fallSumaUdi) {

                //  Mensaje de validacion
                this.planes.pagoAdSumaUdi = this.planes.fallSumaUdi;
                this.planForm.controls['txtpagoAdSumaUdi'].setValue(Number(this.planes.fallSumaUdi).toLocaleString('en-GB') + '.00');
                this.validoPAI = false;


            } else {
                primaUdi = this.calculaPrima(value, this.cuotas.PAI);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.pagoAdPrimaUdi = primaUdi;
                this.planes.pagoAdPrimaPeso = primaPeso;
                this.planes.pagoAdSumaPeso = sumaPeso;
                this.planes.pagoAdSumaUdi = value;
                this.validoPAI = true;

            }
        }
        if (controlName === 'txtpagoAdSumaPeso') {
            if (value > this.planes.fallSumaPeso) {

                this.planes.pagoAdSumaPeso = this.planes.fallSumaPeso;
                this.planForm.controls['txtpagoAdSumaPeso'].setValue(this.planes.fallSumaPeso);

                this.validoPAI = false;

            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.PAI);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.pagoAdPrimaUdi = primaUdi;
                this.planes.pagoAdPrimaPeso = primaPeso;
                this.planes.pagoAdSumaPeso = value;
                this.planes.pagoAdSumaUdi = sumaUdi;
                this.validoPAI = true;

            }
        }

        if (controlName === 'txtpagoAdSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion


                this.planes.pagoAdSumaDolar = this.planes.fallSumaDolar;
                this.planForm.controls['txtpagoAdSumaDolar'].setValue(this.planes.fallSumaDolar);

                this.validoPAI = false;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.PAI);

                this.planes.pagoAdPrimaUdi = 0;
                this.planes.pagoAdPrimaDolar = primaDolar;
                this.planes.pagoAdSumaDolar = value;
                this.planes.pagoAdSumaUdi = 0;
                this.validoPAI = true;

            }
        }

        if (controlName === 'txtconyuSumaUdi') {
            if (value > this.planes.fallSumaUdi) {
                //  Mensaje de validacion 
                this.planes.conyuSumaUdi = this.planes.fallSumaUdi;
                this.planForm.controls['txtconyuSumaUdi'].setValue(Number(this.planes.fallSumaUdi).toLocaleString('en-GB') + '.00');
                this.validoCC = false;

            } else {
                primaUdi = this.calculaPrima(value, this.cuotas.CC);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.conyuPrimaUdi = primaUdi;
                this.planes.conyuPrimaPeso = primaPeso;
                this.planes.conyuSumaPeso = sumaPeso;
                this.planes.conyuSumaUdi = value;
            }
        }
        if (controlName === 'txtconyuSumaPeso') {
            if (value > this.planes.fallSumaPeso) {
                //  Mensaje de validacion
                this.planes.conyuSumaPeso = this.planes.fallSumaPeso;
                this.planForm.controls['txtconyuSumaPeso'].setValue(this.planes.fallSumaPeso);
                this.validoCC = false;
            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.CC);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.conyuPrimaUdi = primaUdi;
                this.planes.conyuPrimaPeso = primaPeso;
                this.planes.conyuSumaPeso = value;
                this.planes.conyuSumaUdi = sumaUdi;
            }
        }
        if (controlName === 'txtconyuSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion
                this.planes.conyuSumaDolar = this.planes.fallSumaDolar;
                this.planForm.controls['txtconyuSumaDolar'].setValue(this.planes.fallSumaDolar);
                this.validoCC = false;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.CC);

                this.planes.conyuPrimaUdi = 0;
                this.planes.conyuPrimaDolar = primaDolar;
                this.planes.conyuSumaDolar = value;
                this.planes.conyuSumaUdi = 0;
            }
        }

        if (controlName === 'txtmAcciSumaUdi') {
            if (value > this.planes.fallSumaUdi) {
                //  Mensaje de validacion
                this.planes.mAcciSumaUdi = this.planes.fallSumaUdi;
                this.planForm.controls['txtmAcciSumaUdi'].setValue(Number(this.planes.fallSumaUdi).toLocaleString('en-GB') + '.00');
                this.validoDI = false;

            } else {
                primaUdi = this.calculaPrima(value, this.cuotas.DI);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.mAcciPrimaUdi = primaUdi;
                this.planes.mAcciPrimaPeso = primaPeso;
                this.planes.mAcciSumaPeso = sumaPeso;
                this.planes.mAcciSumaUdi = value;
            }
        }
        if (controlName === 'txtmAcciSumaPeso') {
            if (value > this.planes.fallSumaPeso) {
                //  Mensaje de validacion
                this.planes.mAcciSumaPeso = this.planes.fallSumaPeso;
                this.planForm.controls['txtmAcciSumaPeso'].setValue(this.planes.fallSumaPeso);
                this.validoDI = false;

            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.DI);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.mAcciPrimaUdi = primaUdi;
                this.planes.mAcciPrimaPeso = primaPeso;
                this.planes.mAcciSumaPeso = value;
                this.planes.mAcciSumaUdi = sumaUdi;
            }
        }
        if (controlName === 'txtmAcciSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion
                this.planes.mAcciSumaDolar = this.planes.fallSumaDolar;
                this.planForm.controls['txtmAcciSumaDolar'].setValue(this.planes.fallSumaDolar);
                this.validoDI = false;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.DI);
                this.planes.mAcciPrimaUdi = 0;
                this.planes.mAcciPrimaDolar = primaDolar;
                this.planes.mAcciSumaDolar = value;
                this.planes.mAcciSumaUdi = 0;
            }
        }

        if (controlName === 'txtmPerOrgSumaUdi') {
            if (value > this.planes.fallSumaUdi) {
                //  Mensaje de validacion 
                this.planes.mPerOrgSumaUdi = this.planes.fallSumaUdi;
                this.planForm.controls['txtmPerOrgSumaUdi'].setValue(Number(this.planes.fallSumaUdi).toLocaleString('en-GB') + '.00');
                this.validoDIPO = false;

            } else {
                primaUdi = this.calculaPrima(value, this.cuotas.DIPO);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.mPerOrgPrimaUdi = primaUdi;
                this.planes.mPerOrgPrimaPeso = primaPeso;
                this.planes.mPerOrgSumaPeso = sumaPeso;
                this.planes.mPerOrgSumaUdi = value;
            }
        }
        if (controlName === 'txtmPerOrgSumaPeso') {
            if (value > this.planes.fallSumaPeso) {
                //  Mensaje de validacion
                this.planes.mPerOrgSumaPeso = this.planes.fallSumaPeso;
                this.planForm.controls['txtmPerOrgSumaPeso'].setValue(this.planes.fallSumaPeso);
                this.validoDIPO = false;

            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.DIPO);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.mPerOrgPrimaUdi = primaUdi;
                this.planes.mPerOrgPrimaPeso = primaPeso;
                this.planes.mPerOrgSumaPeso = value;
                this.planes.mPerOrgSumaUdi = sumaUdi;
            }
        }
        if (controlName === 'txtmPerOrgSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion
                this.planes.mPerOrgSumaDolar = this.planes.fallSumaDolar;
                this.planForm.controls['txtmPerOrgSumaDolar'].setValue(this.planes.fallSumaDolar);
                this.validoDIPO = false;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.DIPO);
                this.planes.mPerOrgPrimaUdi = 0;
                this.planes.mPerOrgPrimaDolar = primaDolar;
                this.planes.mPerOrgSumaDolar = value;
                this.planes.mPerOrgSumaUdi = 0;
            }
        }

        if (controlName === 'txtmColeSumaUdi') {
            if (value > this.planes.fallSumaUdi) {
                //  Mensaje de validacion
                this.planes.mColeSumaUdi = this.planes.fallSumaUdi;
                this.planForm.controls['txtmColeSumaUdi'].setValue(Number(this.planes.fallSumaUdi).toLocaleString('en-GB') + '.00');
                this.validoDIPOC = false;

            } else {
                primaUdi = this.calculaPrima(value, this.cuotas.DIPOC);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.mColePrimaUdi = primaUdi;
                this.planes.mColePrimaPeso = primaPeso;
                this.planes.mColeSumaPeso = sumaPeso;
                this.planes.mColeSumaUdi = value;
            }
        }
        if (controlName === 'txtmColeSumaPeso') {
            if (value > this.planes.fallSumaPeso) {
                //  Mensaje de validacion
                this.planes.mColeSumaPeso = this.planes.fallSumaPeso;
                this.planForm.controls['txtmColeSumaPeso'].setValue(this.planes.fallSumaPeso);
                this.validoDIPOC = false;
            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.DIPOC);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.mColePrimaUdi = primaUdi;
                this.planes.mColePrimaPeso = primaPeso;
                this.planes.mColeSumaPeso = value;
                this.planes.mColeSumaUdi = sumaUdi;
            }
        }
        if (controlName === 'txtmColeSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion
                this.planes.mColeSumaDolar = this.planes.fallSumaDolar;
                this.planForm.controls['txtmColeSumaDolar'].setValue(this.planes.fallSumaDolar);
                this.validoDIPOC = false;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.DIPOC);
                this.planes.mColePrimaUdi = 0;
                this.planes.mColePrimaDolar = primaDolar;
                this.planes.mColeSumaDolar = value;
                this.planes.mColeSumaUdi = 0;
            }
        }

        if (controlName === 'txtcancerSumaUdi') {
            if (value > this.planes.fallSumaUdi) {
                //  Mensaje de validacion 
                this.planes.cancerSumaUdi = this.planes.fallSumaUdi;
                this.planForm.controls['txtcancerSumaUdi'].setValue(Number(this.planes.fallSumaUdi).toLocaleString('en-GB') + '.00');
                this.validoIAC = false;

            } else {
                primaUdi = this.calculaPrima(value, this.cuotas.IAC);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.cancerPrimaUdi = primaUdi;
                this.planes.cancerPrimaPeso = primaPeso;
                this.planes.cancerSumaPeso = sumaPeso;
                this.planes.cancerSumaUdi = value;
            }
        }
        if (controlName === 'txtcancerSumaPeso') {
            if (value > this.planes.fallSumaPeso) {
                //  Mensaje de validacion
                this.planes.cancerSumaPeso = this.planes.fallSumaPeso;
                this.planForm.controls['txtcancerSumaPeso'].setValue(Number(this.planes.fallSumaPeso).toLocaleString('en-GB') + '.00');
                this.validoIAC = false;

            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.IAC);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.cancerPrimaUdi = primaUdi;
                this.planes.cancerPrimaPeso = primaPeso;
                this.planes.cancerSumaPeso = value;
                this.planes.cancerSumaUdi = sumaUdi;
            }
        }
        if (controlName === 'txtcancerSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion
                this.planes.cancerSumaDolar = this.planes.fallSumaDolar;
                this.planForm.controls['txtcancerSumaDolar'].setValue(Number(this.planes.fallSumaDolar).toLocaleString('en-GB') + '.00');
                this.validoIAC = false;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.IAC);
                this.planes.cancerPrimaUdi = 0;
                this.planes.cancerPrimaDolar = primaDolar;
                this.planes.cancerSumaDolar = value;
                this.planes.cancerSumaUdi = 0;
            }
        }

        if (controlName === 'txtenfGravSumaUdi') {
            if (value > this.planes.fallSumaUdi) {
                //  Mensaje de validacion 
                this.planes.enfGravSumaUdi = this.planes.fallSumaUdi;
                this.planForm.controls['txtenfGravSumaUdi'].setValue(Number(this.planes.fallSumaUdi).toLocaleString('en-GB') + '.00');
                this.validoPAE = false;

            } else {
                primaUdi = this.calculaPrima(value, this.cuotas.PAE);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.enfGravPrimaUdi = primaUdi;
                this.planes.enfGravPrimaPeso = primaPeso;
                this.planes.enfGravSumaPeso = sumaPeso;
                this.planes.enfGravSumaUdi = value;
            }
        }
        if (controlName === 'txtenfGravSumaPeso') {
            if (value > this.planes.fallSumaPeso) {
                //  Mensaje de validacion
                this.planes.enfGravSumaPeso = this.planes.fallSumaPeso;
                this.planForm.controls['txtenfGravSumaPeso'].setValue(Number(this.planes.fallSumaPeso).toLocaleString('en-GB') + '.00');
                this.validoPAE = false;

            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.PAE);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.enfGravPrimaUdi = primaUdi;
                this.planes.enfGravPrimaPeso = primaPeso;
                this.planes.enfGravSumaPeso = value;
                this.planes.enfGravSumaUdi = sumaUdi;
            }
        }
        if (controlName === 'txtenfGravSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion
                this.planes.enfGravSumaDolar = this.planes.fallSumaDolar;
                this.planForm.controls['txtenfGravSumaDolar'].setValue(Number(this.planes.fallSumaDolar).toLocaleString('en-GB') + '.00');
                this.validoPAE = false;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.PAE);
                this.planes.enfGravPrimaUdi = 0;
                this.planes.enfGravPrimaDolar = primaDolar;
                this.planes.enfGravSumaDolar = value;
                this.planes.enfGravSumaUdi = 0;
            }
        }

        if (controlName === 'txtdesempSumaUdi') {
            if (value > this.planes.fallSumaUdi) {
                //  Mensaje de validacion
                //  this.planes.desempSumaUdi = this.planes.fallSumaUdi;


            } else {
                //  //debugger;
                primaUdi = this.calculaPrima(value, this.cuotas.PCD);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.desempPrimaUdi = primaUdi;
                this.planes.desempPrimaPeso = primaPeso;
            }
        }
        if (controlName === 'txtdesempSumaPeso') {
            if (value > this.planes.fallSumaPeso) {
                //  Mensaje de validacion
                // this.planes.desempSumaPeso = this.planes.fallSumaPeso;

            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.PCD);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.desempPrimaUdi = primaUdi;
                this.planes.desempPrimaPeso = primaPeso;
            }
        }
        if (controlName === 'txtdesempSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion
                // this.planes.desempSumaDolar = this.planes.fallSumaDolar;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.PCD);

                this.planes.desempPrimaUdi = 0;
                this.planes.desempPrimaDolar = primaDolar;
            }
        }

        if (controlName === 'txtfuneSumaUdi') {
            if (value > this.planes.fallSumaUdi) {
                //  Mensaje de validacion
                this.planes.funeSumaUdi = this.planes.fallSumaUdi;
                this.planForm.controls['txtfuneSumaUdi'].setValue(Number(this.planes.fallSumaUdi).toLocaleString('en-GB') + '.00');
                this.validoGF = false;

            } else {
                primaUdi = this.calculaPrima(value, this.cuotas.GF);
                primaPeso = this.udiToPeso(primaUdi);
                sumaPeso = this.udiToPeso(value);
                this.planes.funePrimaUdi = primaUdi;
                this.planes.funePrimaPeso = primaPeso;
                this.planes.funeSumaPeso = sumaPeso;
                this.planes.funeSumaUdi = value;
            }
        }
        if (controlName === 'txtfuneSumaPeso') {
            if (value > this.planes.fallSumaPeso) {
                //  Mensaje de validacion
                this.planes.funeSumaPeso = this.planes.fallSumaPeso;
                this.planForm.controls['txtfuneSumaPeso'].setValue(this.planes.fallSumaPeso);
                this.validoGF = false;
            } else {
                primaPeso = this.calculaPrima((value), this.cuotas.GF);
                primaUdi = this.pesoToUdi(primaPeso);
                sumaUdi = this.pesoToUdi(value);

                this.planes.funePrimaUdi = primaUdi;
                this.planes.funePrimaPeso = primaPeso;
                this.planes.funeSumaPeso = value;
                this.planes.funeSumaUdi = sumaUdi;
            }
        }
        if (controlName === 'txtfuneSumaDolar') {
            if (value > this.planes.fallSumaDolar) {
                //  Mensaje de validacion
                this.planes.funeSumaDolar = this.planes.fallSumaDolar;
                this.planForm.controls['txtfuneSumaDolar'].setValue(this.planes.fallSumaDolar);
                this.validoGF = false;

            } else {
                primaDolar = this.calculaPrima((value), this.cuotas.GF);

                this.planes.funePrimaUdi = 0;
                this.planes.funePrimaDolar = primaDolar;
                this.planes.funeSumaDolar = value;
                this.planes.funeSumaUdi = 0;
            }
        }

    }

    asignaCuotas(tarifas): void {

        tarifas.forEach(element => {
            //   console.log(element);
            ////  //debugger;
            switch (element.Cobertura) {
                case 'BASICA':
                    this.cuotas.BASICA = element.Tarifa;
                    break;
                case 'BI':
                    this.cuotas.BI = element.Tarifa;
                    break;
                case 'PAI':
                    this.cuotas.PAI = element.Tarifa;
                    break;
                case 'CC':
                    this.cuotas.CC = element.Tarifa;
                    break;
                case 'DI':
                    this.cuotas.DI = element.Tarifa;
                    break;
                case 'DIPO':
                    this.cuotas.DIPO = element.Tarifa;
                    break;
                case 'DIPOC':
                    this.cuotas.DIPOC = element.Tarifa;
                    break;
                case 'IAC':
                    this.cuotas.IAC = element.Tarifa;
                    break;
                case 'PAE':
                    this.cuotas.PAE = element.Tarifa;
                    break;
                case 'PCD':
                    this.cuotas.PCD = element.Tarifa;
                    break;
                case 'GF':
                    this.cuotas.GF = element.Tarifa;
                    break;
            }
        });
    }


    desactivaCamposPesos(): void {
        this.planForm.controls['txtpagoAdSumaPeso'].disable();
        this.planForm.controls['txtfuneSumaPeso'].disable();
        this.planForm.controls['txtenfGravSumaPeso'].disable();
        this.planForm.controls['txtcancerSumaPeso'].disable();
        this.planForm.controls['txtmColeSumaPeso'].disable();
        this.planForm.controls['txtmPerOrgSumaPeso'].disable();
        this.planForm.controls['txtmAcciSumaPeso'].disable();
        this.planForm.controls['txtconyuSumaPeso'].disable();




    }

    activaCamposPesos(): void {
        this.planForm.controls['txtpagoAdSumaPeso'].enable();
        this.planForm.controls['txtfuneSumaPeso'].enable();
        this.planForm.controls['txtenfGravSumaPeso'].enable();
        this.planForm.controls['txtcancerSumaPeso'].enable();
        this.planForm.controls['txtmColeSumaPeso'].enable();
        this.planForm.controls['txtmPerOrgSumaPeso'].enable();
        this.planForm.controls['txtmAcciSumaPeso'].enable();
        this.planForm.controls['txtconyuSumaPeso'].enable();
    }

    ocultaCamposDolar(): void {
        this.planForm.controls['txtpagoAdSumaDolar'].enable();
        this.planForm.controls['txtfuneSumaDolar'].enable();
        this.planForm.controls['txtenfGravSumaDolar'].enable();
        this.planForm.controls['txtcancerSumaDolar'].enable();
        this.planForm.controls['txtmColeSumaDolar'].enable();
        this.planForm.controls['txtmPerOrgSumaDolar'].enable();
        this.planForm.controls['txtmAcciSumaDolar'].enable();
        this.planForm.controls['txtconyuSumaDolar'].enable();
    }

    removeCurrencyPipeFormat(formatedNumber): any {
        // //debugger;
        let val = '0';
        val = formatedNumber.toString().replace(',', '').replace(',', '')
        const pattenr = '/[$,]/g';
        val = val.replace(pattenr, '');
        val = val.replace('$', '');
        let result = val;
        return result;
    }

    actualizaValidacionCoberturas(): void {
        this.validoBI = true;
        this.validoPAI = true;
        this.validoCC = true;
        this.validoDI = true;
        this.validoDIPO = true;
        this.validoDIPOC = true;
        this.validoIAC = true;
        this.validoPAE = true;
        this.validoPCD = true;
        this.validoGF = true;
        this.validoBasica = true;

    }

}
